/**
 * The two Hasura actions of "CI von Webseite" (spec 2026-10-03 §4, §6.2, C6):
 * webseiteLesen (browser only) → { token, kurz } and ciZuordnen(token) → the
 * proposal (§6.2), both one JSON field, called with fetchPolicy 'no-cache' (M5).
 * Errors are thrown as Error(code); the panel translates the codes
 * (settings.ciBrandKit.import.fehler.<code>), unknown ones as 'allgemein'.
 */
import gql from 'graphql-tag';

const WEBSEITE_LESEN = gql`
mutation webseiteLesen($ziel: String!, $id: Int!, $urls: [String!]!, $sprache: String!) {
  webseiteLesen(ziel: $ziel, id: $id, urls: $urls, sprache: $sprache)
}
`;
const CI_ZUORDNEN = gql`
mutation ciZuordnen($token: String!) {
  ciZuordnen(token: $token)
}
`;

// Codes of webmag-database functions/src/webmag-kern/ciVonWebseite.ts (CiFehlerCode).
export const BEKANNT = new Set([
  'eingabe', 'blockiert', 'anmeldung', 'robots', 'botschutz', 'nichtErreichbar', 'zuGross', 'zeit',
  'beschaeftigt', 'limit', 'abgelaufen', 'ki', 'kiAbgelehnt', 'zugriff',
]);

/** One code per failure; the server sends it as the message (or extensions.code). */
function fehlerCode(err) {
  const g = err && err.graphQLErrors && err.graphQLErrors[0];
  const code = (g && g.extensions && g.extensions.code) || (g && g.message) || (err && err.message);
  return BEKANNT.has(code) ? code : 'allgemein';
}

async function rufen(apollo, mutation, variables, feld) {
  try {
    const { data } = await apollo.mutate({ mutation, variables, fetchPolicy: 'no-cache' });
    const wert = data && data[feld];
    // Hasura's scalar JSON may arrive as a string.
    return String(wert) === wert ? JSON.parse(wert) : wert;
  } catch (err) {
    throw new Error(fehlerCode(err));
  }
}

/** Step 1: { token, kurz: { domain, seiten, warnungen, robotsHinweis } }. ziel 'project' | 'folder'. */
export function webseiteLesen(apollo, variables) {
  return rufen(apollo, WEBSEITE_LESEN, variables, 'webseiteLesen');
}

/** Step 2: the proposal (§6.2). */
export function ciZuordnen(apollo, token) {
  return rufen(apollo, CI_ZUORDNEN, { token }, 'ciZuordnen');
}
